<template>
  <div class="ss-g" :class="ctl.isPhone ? 'ss-g1' : 'ss-g2 ss-g2--eq'">
    <div class="ss-gm">
      <set-card id="izv" :title="$t('settings_shell.options.reports_card')">
        <set-switch path="izvestaj" :title="$t('settings_shell.options.report')" :desc="$t('delivery_report_available_for_users')" />
        <set-switch path="worker" :title="$t('settings_shell.options.pickup_branch')" :desc="$t('enable_meal_pickup_another_branch')" />
        <set-switch path="can_reserve" :title="$t('settings_shell.options.spare_meals')" :desc="$t('enable_spare_meal_belated_user')" />
      </set-card>
    </div>
    <div class="ss-gm">
      <set-card id="kantina" :title="$t('settings_shell.options.canteen_card')">
        <set-switch path="confirm_delivery" :title="$t('settings_shell.options.auto_delivery')" :desc="$t('automatic_delivery_no_confirm')" />
        <div class="ss-sw ss-sw--field">
          <div class="ss-sw__t">
            <b>{{ $t("settings_shell.options.timer") }}</b>
            <span>{{ $t("settings_shell.options.timer_d") }}</span>
          </div>
          <set-stepper path="timer" :aria="$t('settings_shell.options.timer')" :min="1" :max="60" :unit="$t('seconds')" />
        </div>
      </set-card>
    </div>
  </div>
</template>

<script>
import SetCard from "../parts/SetCard.vue";
import SetSwitch from "../parts/SetSwitch.vue";
import SetStepper from "../parts/SetStepper.vue";

/** Opcije za firme: izvještaji i preuzimanje, rezervni obroci, isporuka i ekran kantine. */
export default {
  name: "ScreenOptions",
  components: { SetCard, SetSwitch, SetStepper },
  inject: { ctl: "settingsCtl" },
};
</script>
